import { Controller } from "@hotwired/stimulus"
import maplibregl from "maplibre-gl"

export default class extends Controller {
  static targets = ["map"]
  static values = {
    polygon: String,
    points: String
  }

  connect() {
    try {
      this.#setup()
    } catch(e) {
      console.error("order-map controller error:", e)
    }
  }

  disconnect() {
    this.map?.remove()
  }

  #setup() {
    const polygon = JSON.parse(this.polygonValue)
    const coords = polygon.features[0].geometry.coordinates[0]
    const bounds = coords.reduce(
      (b, c) => b.extend(c),
      new maplibregl.LngLatBounds(coords[0], coords[0])
    )

    this.map = new maplibregl.Map({
      container: this.mapTarget,
      style: "https://tiles.openfreemap.org/styles/liberty",
      bounds: bounds,
      fitBoundsOptions: { padding: 40, animate: false },
      doubleClickZoom: false
    })

    this.map.on("error", (e) => console.error("MapLibre error:", e.error))
    this.map.on("load", () => {
      this.mapTarget.querySelector(".maplibregl-ctrl-attrib")?.classList.add("maplibregl-compact")
      this.#initLayers(polygon)
    })
  }

  #initLayers(polygon) {
    const points = JSON.parse(this.pointsValue)

    this.map.addSource("polygon", { type: "geojson", data: polygon })
    this.map.addLayer({
      id: "polygon-fill",
      type: "fill",
      source: "polygon",
      paint: { "fill-color": "#5C3317", "fill-opacity": 0.15 }
    })
    this.map.addLayer({
      id: "polygon-outline",
      type: "line",
      source: "polygon",
      paint: { "line-color": "#5C3317", "line-width": 2 }
    })

    this.map.addSource("addresses", { type: "geojson", data: points })
    this.map.addLayer({
      id: "address-dots",
      type: "circle",
      source: "addresses",
      paint: {
        "circle-radius": 2,
        "circle-color": "#5C3317",
        "circle-opacity": 0.6
      }
    })
  }
}
